// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"blog-posts-view_shadow__Zt5Gs","blogPost":"blog-posts-view_blogPost__2rEvX","pager":"blog-posts-view_pager__1krct"};